import { ShieldAlert } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Button from './Button';

interface Props {
  moduleName: string;
}

function LicenseRequired({ moduleName }: Props) {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center py-20 px-4 text-center">
      <div className="bg-amber-50 p-5 rounded-full mb-6">
        <ShieldAlert className="h-10 w-10 text-amber-500" />
      </div>
      <h2 className="text-xl font-semibold text-neutral-900 mb-2">License Required</h2>
      <p className="text-neutral-600 max-w-sm mb-1">
        You don&apos;t have a license for{' '}
        <span className="font-medium">{moduleName}</span>.
      </p>
      <p className="text-sm text-neutral-500 mt-3">
        Contact your administrator to request a license for this module.
      </p>
      <Button
        variant="outline"
        className="mt-6"
        onClick={() => navigate('/dashboard')}
      >
        Back to Dashboard
      </Button>
    </div>
  );
}

export default LicenseRequired;
